import { useMsal } from '@azure/msal-react';

import { useLoginRequest } from './useLoginRequest';

export const useLogin = () => {
  const { instance: msal } = useMsal();
  const { loginRequest } = useLoginRequest();

  const login = (): void => {
    msal.loginRedirect(loginRequest);   
  };

  return { login };
};